<template>
  <!-- Experience Modal -->
  <div id="view_banked_time_details_modal" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header">


          <h5 class="modal-title ms-5">Banked Time</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="fas fa-times"></i>
          </button>

        </div>
        <div class="modal-body" v-if="usersData.length || !loader">
          <form>
            <div class="form-scroll">
              <div class="d-grid gap-2 d-md-flex justify-content-md-between mb-5">
                <div class="h3">{{ userData.name }}</div>
                <div>
                  <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_banked_time"
                    type="button" @click="addBankedTime(usersData)">Add Banked Time</button>
                  <!-- <button class="btn btn-primary" type="button">Add Initial Banked Time</button> -->
                </div>

              </div>
              <div class="card">
                <div class="card-body">

                  <div class="row">
                    <h3 class="card-title">
                      Select Date Range
                    </h3>


                    <div class="col-sm-6 col-md-4">
                      <div class="input-block mb-3 form-focus position-relative">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                          style="z-index: 100; font-size: 12px;">Start Date</label>
                        <div class="cal-icon" style="z-index: 90;">
                          <date-picker v-model="startDate" placeholder="Start Date"
                            class="form-control floating datetimepicker" :editable="true" :clearable="false"
                            :inputFormat="dateFormat" key="banked-start-date" @update:model-value="loadBank" />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-4">
                      <div class="input-block mb-3 form-focus position-relative">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                          style="z-index: 100; font-size: 12px;">End Date</label>
                        <div class="cal-icon" style="z-index: 90;">
                          <date-picker v-model="endDate" placeholder="End Date"
                            class="form-control floating datetimepicker" :editable="true" :clearable="false"
                            :inputFormat="dateFormat" key="banked-end-date" @update:model-value="loadBank" />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-4">
                      <div class="input-block mb-3 form-focus position-relative">
                        <label class="position-absolute top-0 start-0 ps-2 pt-1 lh-1 text-black"
                          style="z-index: 100; font-size: 12px;">Status</label>
                        <select v-model="selectedStatus" class="form-select form-control floating"
                          style="z-index: 90; height: 50px; padding-top: 18px; padding-left: 10px; border: 1px solid #e3e3e3; font-size: 14px;" @change="loadBank">
                          <option value="PENDING">Pending</option>
                          <option value="ACCEPTED">Accepted</option>
                          <option value="REJECTED">Rejected</option>
                          <option value="ALL">All</option>
                        </select>
                      </div>
                    </div>


                    <div class="col-md-6 mt-4">
                      <div class="card">
                        <div class="card-body">
                          <h3 class="card-title mt-3 ms-3">
                            Total accepted value
                          </h3>
                          <div class="pa-2">
                            {{ userData.accepted_banked_time ? toTimeString(userData.accepted_banked_time) : 0 }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mt-4">
                      <div class="card">
                        <div class="card-body">
                          <h3 class="card-title mt-3 ms-3">
                            Records
                          </h3>
                          <div class="container">
                            <div class="row row-cols-2 row-cols-md-2 row-cols-lg-4 g-2 g-lg-3">
                              <div class="col">
                                <div class="p-2 border bg-light rounded">Total: {{ userData.total_banked_time ?
                                  toTimeString(userData.total_banked_time) : 0 }}</div>
                              </div>
                              <div class="col">
                                <div class="p-2 border bg-light rounded">Accepted: {{ userData.accepted_banked_time
                                  ? toTimeString(userData.accepted_banked_time) : 0 }}</div>

                              </div>
                              <div class="col">
                                <div class="p-2 border bg-light rounded">Pending: {{ userData.pending_banked_time ?
                                  toTimeString(userData.pending_banked_time) : 0 }}</div>
                              </div>
                              <div class="col">
                                <div class="p-2 border bg-light rounded">Rejected: {{ userData.rejected_banked_time
                                  ? toTimeString(userData.rejected_banked_time) : 0 }}</div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">

                      <div v-if="!loader">
                        <!-- Bulk Actions Toolbar -->
                        <div v-if="selectedRowKeys.length > 0" class="bulk-actions-bar d-flex flex-wrap align-items-center justify-content-between p-3 mb-3 rounded bg-light border shadow-sm">
                          <div class="d-flex align-items-center mb-2 mb-md-0">
                            <span class="badge bg-primary fs-6 me-2">{{ selectedRowKeys.length }}</span>
                            <span class="fw-semibold text-dark">{{ selectedRowKeys.length === 1 ? '1 entry selected' : selectedRowKeys.length + ' entries selected' }}</span>
                            <button type="button" class="btn btn-link btn-sm text-decoration-none ms-2 text-muted" @click="clearSelection" :disabled="bulkLoading">
                              <i class="fa-solid fa-xmark me-1"></i>Deselect All
                            </button>
                          </div>
                          <div class="d-flex align-items-center flex-wrap gap-2">
                            <button
                              type="button"
                              class="btn btn-success btn-sm d-flex align-items-center gap-1 text-white"
                              :disabled="bulkLoading"
                              @click="bulkUpdateStatus('Accepted')"
                            >
                              <span v-if="bulkLoading && activeBulkAction === 'Accepted'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                              <i v-else class="fa-solid fa-check"></i>
                              Accept Selected
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger btn-sm d-flex align-items-center gap-1 text-white"
                              :disabled="bulkLoading"
                              @click="bulkUpdateStatus('Rejected')"
                            >
                              <span v-if="bulkLoading && activeBulkAction === 'Rejected'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                              <i v-else class="fa-solid fa-xmark"></i>
                              Reject Selected
                            </button>
                            <button
                              type="button"
                              class="btn btn-warning btn-sm d-flex align-items-center gap-1 text-dark"
                              :disabled="bulkLoading"
                              @click="bulkRecalculate"
                            >
                              <span v-if="bulkLoading && activeBulkAction === 'Recalculate'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                              <i v-else class="fa-solid fa-arrows-rotate"></i>
                              Recalculate Selected
                            </button>
                            <div class="dropdown">
                              <button
                                class="btn btn-outline-secondary btn-sm dropdown-toggle d-flex align-items-center gap-1"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                :disabled="bulkLoading"
                              >
                                <span v-if="bulkLoading && activeBulkAction === 'Pending'" class="spinner-border spinner-border-sm me-1" role="status"></span>
                                More Options
                              </button>
                              <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                                <li>
                                  <a class="dropdown-item d-flex align-items-center" href="javascript:;" @click="bulkUpdateStatus('Pending')">
                                    <i class="fa-solid fa-clock-rotate-left me-2 text-warning"></i>Mark as Pending
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div class="table-responsive overflow-visible">

                          <a-table class="stripped table-hover" :columns="columns"
                            :data-source="userData.banked_times" :pagination="false"
                            row-key="id"
                            v-if="userData.banked_times && userData.banked_times.length">
                            <template #headerCell="{ column }">
                              <template v-if="column.key === 'selection'">
                                <div class="form-check d-flex justify-content-center m-0">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="isAllSelected"
                                    :indeterminate.prop="isIndeterminate"
                                    @change="toggleSelectAll"
                                    title="Select / Deselect All"
                                    style="cursor: pointer;"
                                  />
                                </div>
                              </template>
                            </template>
                            <template #bodyCell="{ column, record }">
                              <template v-if="column.key === 'selection'">
                                <div class="form-check d-flex justify-content-center m-0">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :checked="selectedRowKeys.includes(record.id)"
                                    @change="toggleSelectRow(record.id)"
                                    style="cursor: pointer;"
                                  />
                                </div>
                              </template>
                              <template v-else-if="column.key === 'date'">

                                {{ record.formatted_date ? record.formatted_date : record.date }}

                              </template>
                              <template v-else-if="column.key === 'work_in_minutes'">

                                {{ toTimeString(record.work_in_minutes) }}

                              </template>
                              <template v-else-if="column.key === 'status' || column.key === 'Status'">

                                <span :class="getStatusBadgeClass(record.status || record.Status)">
                                  {{ record.status || record.Status }}
                                </span>

                              </template>
                              <template v-else-if="column.key === 'updated_by'">
                                {{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.updated_by && record.updated_by.first_name ? (record.updated_by.first_name + ' ' + record.updated_by.last_name) : (record.updated_by ? record.updated_by : '--')) }}
                              </template>
                              <template v-else-if="column.key === 'updated_at'">
                                {{ record.updated_at ? formatDateTimeStandardWithTime(record.updated_at) : '--' }}
                              </template>
                              <!-- <template v-else-if="column.key === 'Role'">
                                {{ companyIdToCompanyRole(record.company_role_id) }}
                              </template> -->
                              <template v-else-if="column.key === 'action'">
                                <div>
                                  <!-- class="text-end" -->
                                  <div class="dropdown dropdown-action">
                                    <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                                      aria-expanded="false"><i class="material-icons">more_vert</i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                      <a class="dropdown-item" href="javascript:;"
                                        @click="updateStatus(record.id, 'Accepted')"><i
                                          class="fa-solid fa-check m-r-5 text-success"></i>Accept</a>
                                      <a class="dropdown-item" href="javascript:;"
                                        @click="updateStatus(record.id, 'Rejected')"><i
                                          class="fa-solid fa-xmark m-r-5 text-danger"></i>Reject</a>
                                      <a class="dropdown-item" href="javascript:;"
                                        @click="updateStatus(record.id, 'Pending')"><i
                                          class="fa-solid fa-clock-rotate-left m-r-5 text-warning"></i>Mark as Pending</a>
                                      <a class="dropdown-item" href="javascript:;"
                                        @click="recalculateRecord(record.id)"><i
                                          class="fa-solid fa-arrows-rotate m-r-5"></i>Recalculate</a>
                                      <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                                        data-bs-target="#banked_time_details_modal"
                                        @click="view(record, userData.name)"><i
                                          class="fa-solid fa-eye m-r-5"></i>View</a>
                                      <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                                        data-bs-target="#edit_banked_time_modal" @click="edit(record)"><i
                                          class="fa-solid fa-pencil m-r-5"></i>Edit</a>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                          </a-table>
                          <div v-else>
                            <div class="card text-center">
                              <div class="card-body">
                                <img src="../../assets/img/avatar/no-data.png" alt="no-data" srcset=""
                                  class="responsive-img">
                                <p>No Banked Time Data.</p>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="d-flex justify-content-center">
                            <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total"
                              @change="getUsers" show-less-items class="mt-3 ">
                              <template #itemRender="{ type, originalElement }">
                                <a v-if="type === 'prev'">Previous</a>
                                <a v-else-if="type === 'next'">Next</a>
                                <component :is="originalElement" v-else></component>
                              </template>
                            </a-pagination>
                          </div> -->
                        </div>

                      </div>
                      <div class="d-flex justify-content-center text-center mt-5" v-else>
                        <div class="spinner-border" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </form>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-else>
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- /Experience Modal -->
  <edit-banked-time-modal ref="editBankedTime"></edit-banked-time-modal>
  <banked-time-details-modal ref="viewBankedTime"></banked-time-details-modal>
  <add-banked-time-modal ref="addBankedTime"></add-banked-time-modal>

</template>
<script>
import axios from 'axios';
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../config";
import { getImage, formatDateForApi } from "@/utils/util-funcitons";
import { minToTimeString, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
const columns = [
  {
    title: "",
    key: "selection",
    width: 45,
    align: "center",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date"
  },
  {
    title: "Banked Time",
    dataIndex: "work_in_minutes",
    key: "work_in_minutes",
    // sorter: true,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    // sorter: true,
  },
  {
    title: "Updated By",
    dataIndex: "updated_by",
    key: "updated_by",
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
  },
  {
    title: "Action",
    // sorter: true,
    key: "action",
  },
];

export default {
  data() {
    const today = new Date();
    return {
      columns,
      title: "Banked Time",
      path: "Dashboard",
      text1: "Banked Time",
      usersData: [],
      userId: "",
      perPage: 10,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      company_role_id: "",
      companyId: [],
      loader: false,
      startDate: new Date(),
      endDate: new Date(today.getFullYear(), 11, 31),
      dateFormat: 'dd/MM/yyyy',
      selectedStatus: 'PENDING',
      savedScrollTop: 0,
      recalculating: false,
      selectedRowKeys: [],
      bulkLoading: false,
      activeBulkAction: ""
    };
  },
  computed: {
    userData() {
      return this.usersData[0] || { name: '', accepted_banked_time: 0, total_banked_time: 0, pending_banked_time: 0, rejected_banked_time: 0, banked_times: [] };
    },
    isAllSelected() {
      const items = this.userData?.banked_times || [];
      return Boolean(items.length > 0 && this.selectedRowKeys.length === items.length);
    },
    isIndeterminate() {
      return Boolean(this.selectedRowKeys.length > 0 && !this.isAllSelected);
    }
  },
  mounted() {
    this.initModalListeners();
  },

  methods: {
    saveScrollTop() {
      const modalEl = document.getElementById('view_banked_time_details_modal');
      if (modalEl) {
        const modalBody = modalEl.querySelector('.modal-body');
        this.savedScrollTop = (modalBody ? modalBody.scrollTop : 0) || modalEl.scrollTop || 0;
      }
    },
    initModalListeners() {
      const subModalIds = ['edit_banked_time_modal', 'banked_time_details_modal', 'add_banked_time'];
      subModalIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) {
          el.addEventListener('hidden.bs.modal', () => {
            const mainModalEl = document.getElementById('view_banked_time_details_modal');
            if (mainModalEl) {
              const modal = Modal.getOrCreateInstance(mainModalEl);
              modal.show();
            }
          });
        }
      });

      const mainModalEl = document.getElementById('view_banked_time_details_modal');
      if (mainModalEl) {
        let scrollInterval;

        mainModalEl.addEventListener('show.bs.modal', () => {
          if (this.savedScrollTop > 0) {
            scrollInterval = setInterval(() => {
              const modalBody = mainModalEl.querySelector('.modal-body');
              if (modalBody) modalBody.scrollTop = this.savedScrollTop;
              mainModalEl.scrollTop = this.savedScrollTop;
            }, 10);
          }
        });

        mainModalEl.addEventListener('shown.bs.modal', () => {
          if (scrollInterval) {
            clearInterval(scrollInterval);
          }
          if (this.savedScrollTop > 0) {
            const modalBody = mainModalEl.querySelector('.modal-body');
            if (modalBody) modalBody.scrollTop = this.savedScrollTop;
            mainModalEl.scrollTop = this.savedScrollTop;
            
            setTimeout(() => { 
              if (modalBody) modalBody.scrollTop = this.savedScrollTop;
              mainModalEl.scrollTop = this.savedScrollTop; 
              this.savedScrollTop = 0;
            }, 50);
          }
        });
      }
    },
    updateValues(data, date) {
      this.selectedRowKeys = [];
      this.userId = data.id;
      this.startDate = date.start_date ? new Date(date.start_date) : new Date();
      this.endDate = date.end_date ? new Date(date.end_date) : new Date(new Date().getFullYear(), 11, 31);
      this.selectedStatus = 'PENDING';
      this.getData()
    },

    edit(item) {
      this.saveScrollTop();
      this.$refs.editBankedTime.updateValues(item);
    },

    view(item, name) {
      this.saveScrollTop();
      this.$refs.viewBankedTime.updateValues(item, name);
    },

    addBankedTime(data) {
      this.saveScrollTop();
      this.$refs.addBankedTime.updateValues(data);
    },

    getImage,
    loadBank() {
      this.selectedRowKeys = [];
      this.getData();
    },
    loadFullYearBank() {
      this.selectedRowKeys = [];
      const today = new Date();
      this.startDate = new Date(today.getFullYear(), 0, 1); // January 1st of current year
      this.endDate = new Date(today.getFullYear(), 11, 31); // December 31st of current year
      this.getData();
    },
    getData() {
      this.loader = true;
      this.usersData = [];
      this.selectedRowKeys = [];
      if (!this.userId) {
        this.loader = false;
        return;
      }

      const params = {
        start_date: formatDateForApi(this.startDate),
        end_date: formatDateForApi(this.endDate),
        status: this.selectedStatus
      }
      axios.get(`${VUE_APP_API_BASE_URL}/task/${this.userId}/show`, { params: params })
        .then((response) => {

            if (response.data.status) {
              this.usersData = response.data.data;
              this.usersData.map(element => {
                element["name"] = element["first_name"] + " " + element["last_name"];
              });
              this.usersData[0].banked_times.forEach(element => {
                element["us_date"] = element["date"];
                element["formatted_date"] = this.formatDate(element["date"]);
                  });

          } else {
              this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });

    },

    formatDateTimeStandardWithTime,
    toTimeString(minutes) {
      return minToTimeString(minutes);
    },

    async updateStatus(id, option) {
      await axios.post(`${VUE_APP_API_BASE_URL}/task/${id}/update-status`, {
        status: option,
      }).then((response) => {

        if (response.data.status) {
          this.$toast.success(response.data.message);
          this.getData();
        } else {
          this.$toast.error(response.data.message || response.data.errors);
          // this.errorMessage = response.data.message ?? "";
        }

      }).catch(function (error) {
        console.log('error ', error);
      });
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const parts = dateString.split('-');
      if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const monthIndex = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[monthIndex];
        
        const getOrdinalSuffix = (d) => {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1:  return "st";
            case 2:  return "nd";
            case 3:  return "rd";
            default: return "th";
          }
        };
        
        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
      }
      
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = date.getDate();
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      
      const getOrdinalSuffix = (d) => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1:  return "st";
          case 2:  return "nd";
          case 3:  return "rd";
          default: return "th";
        }
      };
      
      return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    },

    companyIdToCompanyRole(id) {
      const company = this.companyId.find(item => item.id === id);
      return company ? company.name : null;
    },

    async recalculateRange() {
      if (!this.userId) return;
      this.recalculating = true;
      const payload = {
        user_id: this.userId,
        start_date: formatDateForApi(this.startDate),
        end_date: formatDateForApi(this.endDate),
      };
      await axios.post(`${VUE_APP_API_BASE_URL}/task/recalculate-range`, payload)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.getData();
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        })
        .catch((error) => {
          console.error('Recalculate error:', error);
          this.$toast.error('Recalculation failed');
        })
        .finally(() => {
          this.recalculating = false;
        });
    },

    async recalculateRecord(id) {
      await axios.get(`${VUE_APP_API_BASE_URL}/task/${id}/recalculate`)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success('Record recalculated successfully');
            this.getData();
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        })
        .catch((error) => {
          console.error('Recalculate record error:', error);
          this.$toast.error('Recalculation failed');
        });
    },

    toggleSelectAll(e) {
      const items = this.userData?.banked_times || [];
      if (e.target.checked) {
        this.selectedRowKeys = items.map(item => item.id);
      } else {
        this.selectedRowKeys = [];
      }
    },

    toggleSelectRow(id) {
      const index = this.selectedRowKeys.indexOf(id);
      if (index > -1) {
        this.selectedRowKeys.splice(index, 1);
      } else {
        this.selectedRowKeys.push(id);
      }
    },

    clearSelection() {
      this.selectedRowKeys = [];
    },

    getStatusBadgeClass(status) {
      if (!status) return 'badge bg-light text-dark';
      const s = status.toUpperCase();
      if (s === 'ACCEPTED') return 'badge bg-success-light text-success border border-success';
      if (s === 'REJECTED') return 'badge bg-danger-light text-danger border border-danger';
      if (s === 'PENDING') return 'badge bg-warning-light text-warning border border-warning';
      return 'badge bg-light text-dark';
    },

    async bulkUpdateStatus(option) {
      if (!this.selectedRowKeys.length) return;
      this.bulkLoading = true;
      this.activeBulkAction = option;
      try {
        const promises = this.selectedRowKeys.map(id =>
          axios.post(`${VUE_APP_API_BASE_URL}/task/${id}/update-status`, {
            status: option
          })
        );
        const results = await Promise.allSettled(promises);
        const successful = results.filter(r => r.status === 'fulfilled' && r.value?.data?.status).length;
        const failed = results.length - successful;

        if (successful > 0) {
          this.$toast.success(`Successfully updated ${successful} record(s) to ${option}`);
        }
        if (failed > 0) {
          this.$toast.error(`Failed to update ${failed} record(s)`);
        }
        this.selectedRowKeys = [];
        this.getData();
      } catch (error) {
        console.error('Bulk update error:', error);
        this.$toast.error('An error occurred during bulk update');
      } finally {
        this.bulkLoading = false;
        this.activeBulkAction = '';
      }
    },

    async bulkRecalculate() {
      if (!this.selectedRowKeys.length) return;
      this.bulkLoading = true;
      this.activeBulkAction = 'Recalculate';
      try {
        const promises = this.selectedRowKeys.map(id =>
          axios.get(`${VUE_APP_API_BASE_URL}/task/${id}/recalculate`)
        );
        const results = await Promise.allSettled(promises);
        const successful = results.filter(r => r.status === 'fulfilled' && r.value?.data?.status).length;
        const failed = results.length - successful;

        if (successful > 0) {
          this.$toast.success(`Successfully recalculated ${successful} record(s)`);
        }
        if (failed > 0) {
          this.$toast.error(`Failed to recalculate ${failed} record(s)`);
        }
        this.selectedRowKeys = [];
        this.getData();
      } catch (error) {
        console.error('Bulk recalculate error:', error);
        this.$toast.error('An error occurred during bulk recalculation');
      } finally {
        this.bulkLoading = false;
        this.activeBulkAction = '';
      }
    },

  }
};
</script>
<style scoped>
/* Ensure sub-modals stack above the fullscreen modal */
.modal-fullscreen ~ .modal,
.modal-body .modal {
  z-index: 1070 !important;
}

:deep(.modal-content) {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), 0 5px 15px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
}

.custom-modal .modal-content .modal-header {
  border: 1px inset rgb(58, 58, 58);
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 15px 30px;
  background: #099bf8;
}

h5,
.h5 {
  font-size: 1rem;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 0;
}

.custom-modal .modal-content .modal-header .btn-close {
  background-color: #ffffff00;
  height: 30px;
  width: 30px;
  /* border: 1px solid #ffffff; */
  font-size: 25px;
  transition: all 0.2s ease;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

.bg-success-light {
  background-color: #e8fadf !important;
}

.bg-danger-light {
  background-color: #ffe8e8 !important;
}

.bg-warning-light {
  background-color: #fff8e1 !important;
}

.bulk-actions-bar {
  border-left: 4px solid #099bf8 !important;
  animation: fadeIn 0.2s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
